import classNames from "classnames";
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import icon from "../../Img/submission/icon.png";
import iconWhite from "../../Img/submission/icon_white.png";
import styles from "./Submission.module.scss";
export default function Submission({ isDarkMode }: { isDarkMode: boolean }) {
  const navigate = useNavigate();
  const location = useLocation();
  const job: any = location?.state;
  const onClick = (): void => {
    navigate("/", { replace: true });
  };
  useEffect(() => {
    document.body.style.overflow = "auto";
  }, []);
  return (
    <div className={styles.container}>
      <section className={styles.contents}>
        <img src={icon} alt="" className={styles.icon} />
        <p
          className={classNames(styles.contents_first_context, {
            "display-kr-M": true,
          })}
        >
          {job?.lo === "en"
            ? "Your application has been successfully submitted."
            : "지원서 제출이 완료 되었습니다."}
        </p>
        <p
          className={classNames(styles.contents_second_context, {
            "body-kr-L": true,
          })}
        >
          {job?.lo === "en"
            ? "We aim to inform you of a decision on your application within two weeks."
            : "지원 결과는 작성해 주신 이메일로 2주 안에 알려드릴 예정입니다."}
        </p>
        <div className={styles.contents_email}>
          <p
            className={classNames({
              "body-kr-L": true,
            })}
          >
            {" "}
            {job?.lo === "en" ? "Inquiries" : "채용 문의"} :{" "}
          </p>
          &nbsp;
          <a
            className={classNames({
              "body-kr-L": true,
            })}
            href="mailto:hrmanager@mondayoff.me"
            target="_blank"
            rel="noreferrer"
          >
            hrmanager@mondayoff.me
          </a>
        </div>
        <button
          className={classNames(styles.home_btn, {
            "red-large-button": true,
            "label-kr-L": true,
          })}
          onClick={onClick}
        >
          {job?.lo === "en" ? "Home" : "홈으로 가기"}
        </button>
      </section>
    </div>
  );
}
